import styled from "@emotion/styled";
import { range } from "lodash";
import { useLocale } from "../../../hooks/useLocale";

export const timestampColumnWidth = 80;

export const TimestampColumnWrapper = styled.div`
  width: ${timestampColumnWidth}px;
  padding: 0 10px;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
export const TimestampContainer = styled.div`
  position: relative;
  margin: 0;
  width: 100%;
  height: 60px;
  font-size: 12px;
  line-height: 1em;
`;
export const Timestamp = styled.span`
  position: absolute;
  top: -0.5em;
  right: 0;
`;
export const TimestampColumn = () => {
  const { locale } = useLocale();

  return (
    <TimestampColumnWrapper>
      <TimestampContainer />
      {range(23).map((i) => {
        const hour = i + 1;
        const hourDate = new Date(0);
        hourDate.setHours(hour);
        return (
          <TimestampContainer key={hour}>
            <Timestamp>
              {hourDate.toLocaleTimeString(locale, {
                hour: "numeric",
                minute: "numeric",
              })}
            </Timestamp>
          </TimestampContainer>
        );
      })}
    </TimestampColumnWrapper>
  );
};
